import type { TypePolicies } from '../../../../utils/types/TypePolicies';
import { allSyncSessions } from '../sync-session';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      getSyncSessions: () => allSyncSessions.get(),
    },
  },
};
